import { Link } from "react-router-dom";
import { topComments } from "@/mocks/events";
import { formatCount } from "@/utils/format";

const rankStyles = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-foreground-950",
  "bg-secondary-500 text-background-50",
];

export default function HotCommentRank() {
  const list = [...topComments].sort((a, b) => b.likes - a.likes).slice(0, 5);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="mb-5 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-flashlight-line text-lg text-accent-600"></i>
          热评实时榜
        </h2>
        <Link
          to="/comments"
          className="inline-flex items-center gap-0.5 whitespace-nowrap text-xs font-semibold text-primary-600 transition-colors hover:text-primary-700"
        >
          完整榜单
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <ol className="flex flex-col gap-1">
        {list.map((item, index) => (
          <li key={item.id} className="group flex gap-3 rounded-md p-2.5 transition-colors hover:bg-background-100">
            <span
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs font-black ${
                rankStyles[index] ?? "bg-background-200 text-foreground-700"
              }`}
            >
              {index + 1}
            </span>
            <div className="min-w-0 flex-1">
              <Link
                to={`/event/${item.eventId}`}
                className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600"
              >
                {item.content}
              </Link>
              <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                <span className="truncate">{item.nickname}</span>
                <span className="flex shrink-0 items-center gap-1">
                  <i className="ri-thumb-up-line text-sm text-primary-400"></i>
                  {formatCount(item.likes)}
                </span>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}